import "../styles/home.scss";
import { Core } from '@unseenco/taxi';
import { CustomRenderer, BlogRenderer } from '../components/renderers.js';
import Slide from '../components/transitions.js'; 

const taxi = new Core( {
    renderers: {
        default: CustomRenderer,
        BlogRenderer: BlogRenderer,
    },
    transitions: {
        default: Slide,
    },
});

window.document.addEventListener("DOMContentLoaded", function () {
    window.console.log("taxi loaded at " + taxi.currentLocation.pathname);
  });

  